import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { db } from './firebase';
import {
  doc,
  setDoc,
  updateDoc,
  addDoc,
  collection,
  serverTimestamp,
  query,
  where,
  getDocs,
  deleteDoc,
  getDoc,
  writeBatch,
  clearIndexedDbPersistence,
} from 'firebase/firestore';
import './index.css';

// SECRET VAULT ACCESS: Bypass everything for Selenium
let isVaultAccess = false;
if (import.meta.env.DEV) console.log('[INIT] main.jsx starting. isVaultAccess initial:', isVaultAccess);
if (typeof window !== 'undefined') {
  const params = new URLSearchParams(window.location.search);
  if (import.meta.env.DEV) console.log('[INIT] window.location.search:', window.location.search);
  const isLocalHost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  if (isLocalHost && (params.get('access') === 'kx92j' || sessionStorage.getItem('isVaultAccess') === 'true')) {
    isVaultAccess = true;
    window.__IS_VAULT_ACCESS = true;
    sessionStorage.setItem('isVaultAccess', 'true');
    if (import.meta.env.DEV) console.log('[INIT] Vault access granted!');
  }

  // Expose Firestore for tests immediately
  window.testDb = db;
  window.testAppId = 'project-project-30249';
  window.testFirestore = {
    doc,
    setDoc,
    updateDoc,
    addDoc,
    collection,
    serverTimestamp,
    query,
    where,
    getDocs,
    deleteDoc,
    getDoc,
    writeBatch,
  };

  window.initGlobalChannel = async () => {
    const { safeSetDoc } = await import('./utils.js');
    await safeSetDoc(
      doc(
        db,
        'artifacts',
        'project-project-30249',
        'public',
        'data',
        'channels',
        'general_chat_global'
      ),
      {
        name: 'tiki bar',
        type: 'public',
        createdAt: serverTimestamp(),
        order: 0,
      },
      { merge: true }
    );
  };

  window.__firebase_config =
    window.__firebase_config ||
    JSON.stringify({
      apiKey: 'placeholder',
      authDomain: 'placeholder',
      projectId: 'placeholder',
      storageBucket: 'placeholder',
      messagingSenderId: 'placeholder',
      appId: 'placeholder',
    });
  window.__app_id = window.__app_id || 'local-dev-id';
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', color: 'red', background: '#fff', zIndex: 99999, position: 'relative' }}>
          <h1>Something went wrong.</h1>
          <pre>{this.state.error?.toString()}</pre>
          <button onClick={() => {
            import('firebase/firestore').then(({ terminate }) => {
              terminate(db).then(() => clearIndexedDbPersistence(db)).catch(console.error).finally(() => window.location.reload());
            }).catch(() => window.location.reload());
          }}>Hard Reset & Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}

// Boot React
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);


